import { useEffect, useState } from "react";
import { _CreditAccount, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { _LoanLine } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { TabPills } from "../../../../../bpm/CustomFormNew/CustomForms/CreditoyCartera/Components/TabPills";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import "./AccountCreditSimulator.css"
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { LoanLineEditor } from "../../../../../admin/CreditPotfolio/LoanLine/LoanLineEditor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { Alert } from "../../../../../theme/Component/Alert";

interface BaseProps {
    componentForma?: "Component" | "Menu";
    initialCredit?: {
        IDLoanLine: number;
        CreditValue: number;
        CreditQuotes: number;
        PayDate?: any;
        CutDay?: number;
        CurrentPercentInterest: number;
    };
}

interface propsData {
    IDLoanLine: number;
    MinimumLoanAmount: number;
    MaximumLoanAmount: number;
    QuotaScale: number;
    QuotaRange: string;
    MinQuotas: number;
    MaxQuotas: number;
    CurrentPercentInterest: number;
}

const head = [
    { title: 'No. Cuota', property: 'NoCuota', visible: true, mask: MASK_NUMBER },
    { title: 'Fecha', property: 'FechaCuota', visible: true, mask: MASK_DATE },
    { title: 'Capital', property: 'ValorCapital', visible: true, mask: MASK_MONEY },
    { title: 'Interes', property: 'InteresFijo', visible: true, mask: MASK_MONEY },
    { title: 'Valor Cuota', property: 'ValorCuota', visible: true, mask: MASK_MONEY },
    { title: 'Saldo Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
]

export const AccountCreditSimulator = ({ componentForma = "Menu", initialCredit }: BaseProps) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_CreditAccount);
    const creditline = useDataBean(_LoanLine);

    const [props, setProps] = useState<Partial<propsData>>({});
    const [loanName, setLoanName] = useState<string>("")
    const [stops, setStops] = useState([200000, 5000000])
    const [jump, setJump] = useState(100000)
    const [feesArray, setFeesArray] = useState([{ label: 3, valor: 3 }]);
    const [quotaValue, setQuotaValue] = useState<number>(0);
    const [isValidQuota, setIsValidQuota] = useState<boolean>(false);

    useEffect(() => {
        console.log(initialCredit?.IDLoanLine, props.IDLoanLine)
        if (initialCredit?.IDLoanLine != props.IDLoanLine) {

            creditline.instance.getLoanLine(initialCredit?.IDLoanLine)
                .then((data) => {

                    const cuotas = data.QuotaRange
                        ? data.QuotaRange.split(",").map(v => ({
                            label: Number(v),
                            valor: Number(v),
                        }))
                        : [{ label: 3, valor: 3 }];

                    setFeesArray(cuotas);
                    setLoanName(data.Name);
                    setProps({
                        IDLoanLine: data.IDLoanLine,
                        MinimumLoanAmount: data.MinimumLoanAmount,
                        MaximumLoanAmount: data.MaximumLoanAmount,
                        QuotaScale: data.QuotaScale,
                        QuotaRange: data.QuotaRange,
                        MinQuotas: data.MinQuotas,
                        MaxQuotas: data.MaxQuotas,
                        CurrentPercentInterest: data.CurrentPercentInterest
                    });

                    setStops([data.MinimumLoanAmount, data.MaximumLoanAmount]);
                    setJump(data.QuotaScale ?? 100000);

                    setBean(prev => ({
                        ...prev,
                        CreditValue: initialCredit?.CreditValue,
                        CreditQuotes: initialCredit?.CreditQuotes,
                        PayDate: initialCredit?.PayDate ?? prev.PayDate,
                        CutDay: initialCredit?.CutDay ?? prev.CutDay,
                    }));

                    reseteTableValue();
                });
        } else {
            return;
        }
    }, [initialCredit]);

    const getValorCuota = () => {
        instance.getValueCuoteCredit(bean.CreditValue, props.CurrentPercentInterest, bean.CreditQuotes)
            .then((resp) => {
                setQuotaValue(resp);
                setIsValidQuota(true);
            })
            .catch(() => {
                toast.error("Error al Obtener la cuota");
                setIsValidQuota(false);
            });
    };

    const reseteTableValue = () => {
        setIsValidQuota(false);
        setQuotaValue(0);
        setLista([]);
    }

    const getAmortizacionTable = () => {
        instance.generateAmortizationTable6(bean.CreditValue, props.CurrentPercentInterest, bean.CreditQuotes, null, bean.PayDate, bean.CutDay).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error("No se pudo generar la tabla de amortizacion") })
    }

    const validateForm = () => {
        const { CreditValue, CreditQuotes } = bean;
        const {
            MinQuotas = 1,
            MaxQuotas = Number.MAX_SAFE_INTEGER
        } = props || {};

        if (!CreditValue || !CreditQuotes) {
            toast.error("Debe ingresar el Valor del credito y las Cuotas.");
            setBean({ ...bean, CreditValue: null, CreditQuotes: null });
            return false;
        }

        if ((MinQuotas ? CreditQuotes < MinQuotas : false) || (MaxQuotas ? CreditQuotes > MaxQuotas : false)) {
            toast.error(`Las Cuotas deben estar entre ${MinQuotas} y ${MaxQuotas}`);
            setBean({ ...bean, CreditQuotes: null });
            return false;
        }

        return true;
    };

    const formBase = () => {
        return (
            <div className="row">
                <div className="col-md-6">
                    {!initialCredit ? (
                        <LoanLineEditor
                            IDSelect={props?.IDLoanLine}
                            onChange={(dataLinea) => {
                                const cuotas = dataLinea.QuotaRange
                                    ? dataLinea.QuotaRange.split(",").map(v => ({
                                        label: Number(v),
                                        valor: Number(v)
                                    }))
                                    : [{ label: 3, valor: 3 }];

                                setFeesArray(cuotas);
                                setProps({
                                    IDLoanLine: dataLinea.IDLoanLine,
                                    MinimumLoanAmount: dataLinea.MinimumLoanAmount,
                                    MaximumLoanAmount: dataLinea.MaximumLoanAmount,
                                    QuotaScale: dataLinea.QuotaScale,
                                    QuotaRange: dataLinea.QuotaRange,
                                    MinQuotas: dataLinea.MinQuotas,
                                    MaxQuotas: dataLinea.MaxQuotas,
                                    CurrentPercentInterest: dataLinea.CurrentPercentInterest
                                });
                                setLoanName(dataLinea.Name)

                                setStops([dataLinea.MinimumLoanAmount, dataLinea.MaximumLoanAmount]);
                                setJump(dataLinea.QuotaScale ?? 100000);
                                setBean(prev => ({
                                    ...prev,
                                    CreditQuotes: cuotas[0].valor,
                                    CreditValue: dataLinea.MinimumLoanAmount
                                }));

                                reseteTableValue();
                            }}


                            label="Linea de Credito"
                        />
                    ) : (
                        <div className="p-2">
                            <label>Linea de Crédito:</label>
                            <div>{loanName}</div>
                        </div>
                    )}
                </div>

                <div className="col-md-6">
                    <InputDate name="" value={bean.PayDate} setDate={(e) => { setBean({ ...bean, PayDate: e }) }} notDate label="Fecha de Desembolso" />
                </div>
                <div className="col-md-6">
                    <label>Dia de Corte</label>
                    <select
                        className="form-control"
                        value={bean.CutDay ?? ""}
                        onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                            setBean({ ...bean, CutDay: value })
                        }}
                    >
                        <option value="">DD</option>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>
                                {day.toString().padStart(2, '0')}
                            </option>
                        ))}
                    </select>
                </div>
                <hr className="mt-3" />
                <div className="row mt-3">
                    <div className="col-md-7 d-flex flex-column align-items-center">
                        <div className="w-100 text-center mb-4">
                            <strong className="fw-semibold">
                                <span className="titulres mx-3 fs-5 fst-italic">Valor a financiar</span>
                                <span
                                    className="mx-2 fs-3 text-success"
                                    dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.CreditValue, MASK_MONEY) }}
                                />
                            </strong>
                        </div>

                        <div className="w-100 text-center mb-4">
                            <small>¿Cuál es tu plazo? <span className="text-muted">(Meses)</span></small>
                            <div className="mt-2">
                                <TabPills
                                    defaultValue={initialCredit?.CreditQuotes ?? null}
                                    lista={feesArray}
                                    onSelect={(e) => {
                                        setBean({ ...bean, CreditQuotes: e });
                                        reseteTableValue()
                                    }}
                                />
                            </div>
                        </div>

                        {!initialCredit &&
                            <div className="w-100 mt-2">
                                <div className="row">
                                    <div className="col-md-6">
                                        <small>Desliza aquí para cambiar el valor </small>
                                    </div>
                                    <div className="col-md-6">
                                        <small className="text-muted" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(jump, MASK_MONEY) }}></small>
                                    </div>
                                </div>
                                <input
                                    className="rs-range w-100 mt-4"
                                    type="range"
                                    value={bean.CreditValue}
                                    min={stops[0]}
                                    max={stops[1]}
                                    step={jump}
                                    onChange={(e) => { setBean({ ...bean, CreditValue: parseInt(e.target.value) }); reseteTableValue(); }}
                                />
                                <div className="d-flex justify-content-between mt-4">
                                    <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(stops[0], MASK_MONEY) }} />
                                    <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(stops[1], MASK_MONEY) }} />
                                </div>
                            </div>
                        }
                    </div>

                    <div className="col-1"></div>

                    <div className="col-md-4">
                        <div className="mb-2 d-flex justify-content-between">
                            <strong>Tasa de Interés:</strong>
                            <span>%{props.CurrentPercentInterest}</span>
                        </div>

                        <div className="mb-2 d-flex justify-content-between">
                            <strong>Mínimo a solicitar:</strong>
                            <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props?.MinimumLoanAmount, MASK_MONEY) }} />
                        </div>

                        <div className="mb-2 d-flex justify-content-between">
                            <strong>Máximo a solicitar:</strong>
                            <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props?.MaximumLoanAmount, MASK_MONEY) }} />
                        </div>

                        <div className="mt-4">
                            <BasicButton
                                spinner
                                disable={!bean.CreditValue || !bean.CreditQuotes}
                                icon="ri-send-plane-line"
                                eventClick={() => {
                                    if (!validateForm()) {
                                        toast.error("");
                                    } else {
                                        getValorCuota();
                                    }
                                }}
                            >
                                Simular
                            </BasicButton>
                        </div>

                        <hr className="my-4" />
                        {quotaValue > 0 && (
                            <>
                                <div className="mb-2 d-flex justify-content-between">
                                    <strong>Valor de la Cuota:</strong>
                                    <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(quotaValue, MASK_MONEY) }} />
                                </div>
                                <BasicButton
                                    spinner
                                    disable={!bean.CutDay || !isValidQuota || !bean.PayDate}
                                    icon="ri-send-plane-line"
                                    eventClick={() => getAmortizacionTable()}
                                >
                                    Tabla de Amortizaciones
                                </BasicButton>
                            </>
                        )}

                    </div>
                </div>

                {lista.length > 0 ?
                    <>
                        <hr className="mt-3" />
                        <div className="col-md-12">
                            <BasicTable body={lista} head={head} rowSet={() => { }} customRows={bean.CreditQuotes + 1} />
                        </div>
                    </>
                    :
                    (null)
                }
            </div>
        )
    }

    return componentForma === "Menu" ? (
        <BasicPage titulo="Simulador">
            {formBase()}
        </BasicPage>
    ) : (formBase());
}